<template>
  <div class="equity-box" v-show="pageShow">
    <van-form @submit="onSubmit" label-width="9em" ref="formService">
      <van-cell-group>
        <div class="title-box">
          <h3 class="cell_title">网站信息</h3>
        </div>
        <van-field
          class="required-label"
          name="webSiteName"
          v-model="website.webSiteName"
          label="网站名称"
          placeholder="请输入"
          :rules="webSiteNameRules"
        />
        <van-field
          class="required-label"
          readonly
          clickable
          name="isDomain"
          :value="website.isDomain"
          label="是否有独立域名"
          placeholder="请选择"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择是否有独立域名' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          v-if="website.isDomain === '否'"
          label-width=""
          class="required-label"
          name="rr"
          v-model="website.rr"
          label="站点网址"
          placeholder="请输入"
          :rules="[
            { required: true, message: '请输入站点网址' },
            {
              pattern: /^[a-zA-Z0-9_\-.*@\u4e00-\u9fa5]+$/,
              message: '请输入正确站点网址',
            },
            { validator: checkUrl, message: '域名不可用！' },
          ]"
          :update:model-value="(website.rr = website.rr.replace(/\s+/g, ''))"
        >
          <template #extra>
            <div style="color: #666666">.cnknowledge.com</div>
          </template>
        </van-field>
        <van-field
          v-if="website.isDomain === '是'"
          class="required-label"
          name="webAddress"
          v-model="website.webAddress"
          label="站点网址"
          placeholder="请输入"
          :rules="[
            { required: true, message: '请输入站点网址' },
            {
              pattern: /^[a-zA-Z0-9_\-.*@\u4e00-\u9fa5]+$/,
              message: '请输入正确站点网址',
            },
            { validator: checkUrl, message: '域名不可用！' },
          ]"
          :update:model-value="
            (website.webAddress = website.webAddress.replace(/\s+/g, ''))
          "
        />
        <van-field
          v-if="website.isDomain === '是'"
          class="required-label"
          name="recordNumber"
          v-model="website.recordNumber"
          label="备案号"
          placeholder="请输入"
          :rules="recordNumberRules"
        />
        <van-field
          v-if="website.isDomain === '是'"
          class="required-label"
          readonly
          clickable
          name="certificateDomain"
          :value="website.certificateDomain ? '已上传' : ''"
          label="域名证书"
          placeholder="未设置"
          :rules="[{ required: true, message: '请上传域名证书' }]"
          @click="
            toEdit('/upload-page', {
              objName: 'website',
              key: 'certificateDomain',
              label: '域名证书',
              length: 1,
            })
          "
          is-link
        />
        <van-field
          v-if="website.isDomain === '是'"
          readonly
          clickable
          name="otherMaterial"
          :value="website.otherMaterial ? '已上传' : ''"
          label="其他材料"
          placeholder="未设置"
          @click="
            toEdit('/upload-page', {
              objName: 'website',
              key: 'otherMaterial',
              label: '其他材料',
              length: 3,
            })
          "
          is-link
        />
      </van-cell-group>
      <div class="btn-box">
        <van-button
          class="form_btn"
          round
          block
          type="info"
          native-type="submit"
          :loading="btnLoding"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
  
<script>
import { Toast } from "vant";
export default {
  name: "EquityWebsite",
  data() {
    return {
      pageShow: true,
      btnLoding: false,
      website: {
        webAddress: "",
        rr: "",
        webSiteName: JSON.parse(sessionStorage.getItem("userInfo")).companyName,
        isDomain: "是",
        recordNumber: "",
        certificateDomain: "",
        otherMaterial: "",
      },
      showPicker: false,
      columns: ["是", "否"],
      isCatch: false, // 是否缓存信息
      webSiteNameRules: [
        { required: true, message: "请输入网站名称" },
        { pattern: /^.{1,50}$/, message: "网站名称最多50个字符" },
      ],
      recordNumberRules: [
        { required: true, message: "请输入备案号" },
        { pattern: /^.{1,50}$/, message: "备案号最多50个字符" },
      ],
    };
  },
  created() {
    if (sessionStorage.getItem("website")) {
      let website = JSON.parse(sessionStorage.getItem("website"));
      for (const key in website) {
        this.website[key] = website[key];
      }
    } else {
      this.getPartnerDetail();
    }
  },
  destroyed() {
    if (!this.isCatch) {
      sessionStorage.removeItem("website");
    }
  },
  methods: {
    async getPartnerDetail() {
      const res = await this.$apis.userServe.getPartnerDetail();
      if (res.resultCode === "200") {
        let payMerchant = res.data.payMerchant;
        let businessList = res.content.businessList;
        let businessDetail = businessList.find((item) => item.roleId === "16");
        if (businessDetail.statusCode === 0 && payMerchant.mid) {
          this.website.webAddress = payMerchant.mid;
          this.website.webSiteName = payMerchant.webSiteName;
        } else if (businessDetail.statusCode === 3) {
          this.website = {
            ...this.website,
            ...(businessDetail.extraInfo
              ? JSON.parse(businessDetail.extraInfo)
              : {}),
          };
          this.website.isDomain = this.website.isDomain === true ? "是" : "否";
          let website = JSON.stringify(this.website);
          sessionStorage.setItem("website", website);
        } else if (
          businessDetail.statusCode === 1 ||
          businessDetail.statusCode === 2 ||
          businessDetail.statusCode === 4
        ) {
          this.$router.replace({
            path: "/partner/equity-result",
            query: this.$route.query,
          });
        }
        this.pageShow = true;
      }
    },
    async onSubmit(values) {
      this.btnLoding = true;
      let params = this.$global.deepClone(values);
      let obj = JSON.parse(sessionStorage.getItem("website"));
      if (params.isDomain === "是") {
        params.certificateDomain = obj.certificateDomain;
        params.otherMaterial = obj.otherMaterial;
      } else {
        params.webAddress = params.rr + ".cnknowledge.com";
      }
      params.isDomain = params.isDomain === "是" ? true : false;
      let data = { extraInfo: JSON.stringify(params), roleId: 16 };
      const res = await this.$apis.zzsignServe.equityApply(data);
      if (res.resultCode === "200") {
        this.$router.replace({
          path: "/partner/equity-website-result",
        });
      } else {
        this.btnLoding = false;
        Toast(res.resultDesc);
      }
    },
    onConfirm(value) {
      this.website.isDomain = value;
      this.showPicker = false;
    },
    upload() {
      this.isCatch = true;
      this.$router.push({
        path: "/upload-page",
        query: {
          label: "其他资料",
        },
      });
    },
    // 去编辑
    toEdit(path, query) {
      this.isCatch = true;
      let website = JSON.stringify(this.website);
      sessionStorage.setItem("website", website);
      this.$router.push({ path, query });
    },
    // 校验域名
    async checkUrl(value) {
      const res = await this.$apis.userServe.checkUrl(value);
      if (res.resultCode !== "200") {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.equity-box {
  padding: 12px;
  background-color: #f5f5f5;
  height: calc(100vh - constant(safe-area-inset-top) - 44px);
  height: calc(100vh - env(safe-area-inset-top) - 44px);

  &::v-deep .van-cell-group {
    margin-bottom: 12px;
    padding: 13px 12px 0;
    border-radius: 8px;
    overflow: hidden;

    .cell_title {
      font-size: 15px;
      color: #333333;
    }

    .van-cell {
      padding: 17px 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border: none;
      }

      .van-cell__title {
        color: #333333;
      }

      .van-field__control {
        text-align: right;
      }

      &::after {
        border: none;
      }
    }

    .van-field--error {
      position: relative;
      padding-bottom: 41px;

      .van-cell__title,
      .van-cell__value {
        position: unset;
      }

      .van-field__error-message {
        position: absolute;
        left: 0;
        // text-align: right;
      }

      .van-field__control {
        color: #333;

        &::placeholder {
          color: #333;
        }
      }
    }

    .required-label {
      .van-field__label {
        span {
          &::after {
            content: "*";
            color: red;
          }
        }
      }
    }
  }
}

.btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-top: 6px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 6px) !important;
  padding-bottom: calc(env(safe-area-inset-bottom) + 6px) !important;
  width: 100vw;
  background-color: #fff;
  .form_btn {
    margin: 0 auto;
    width: 345px;
    height: 44px;
    background: #4a79f1;
    border-radius: 22px;
  }
}

.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    height: 28px;
  }
}
</style>
  